export function inventoryTimingLabel(days: number): string {
  const rounded = Math.round(Math.abs(days));
  if (days < 0) return `${rounded}d supplier-funded head start`;
  if (days === 0) return "no cash tied up before sale";
  return `${rounded}d before sale`;
}

export function inventoryEquationDays(days: number): string {
  const rounded = Math.round(days);
  return days < 0 ? `−${Math.abs(rounded)}d` : `${rounded}d`;
}
